import { Tabs } from '../../components/ui/Tabs';
import { GeneralSettings } from './components/GeneralSettings';
import { AccountingSettings } from './components/AccountingSettings';
import { SecuritySettings } from './components/SecuritySettings';
import { NotificationSettings } from './components/NotificationSettings';
import { IntegrationSettings } from './components/IntegrationSettings';
import { AccountingLevelSettings } from '../../components/settings/accounting/AccountingLevelSettings';
import { usePermissions } from '../../hooks/usePermissions';
import { ShieldAlert } from 'lucide-react';

export function SettingsPage() {
  const { can, isAdmin, isAuditor, roleLabel } = usePermissions();
  
  // Les auditeurs n'ont pas accès aux paramètres
  if (isAuditor) {
    return (
      <div className="space-y-6">
        <h1 className="text-2xl font-bold text-foreground">Paramètres</h1>
        <div className="card p-8 text-center">
          <ShieldAlert className="w-16 h-16 mx-auto text-muted-foreground mb-4" />
          <h2 className="text-xl font-semibold text-foreground mb-2">Accès restreint</h2>
          <p className="text-muted-foreground">
            En tant que <strong>{roleLabel}</strong>, vous n'avez pas accès aux paramètres de l'application.
            <br />
            Veuillez contacter un administrateur si vous avez besoin de modifier des paramètres.
          </p>
        </div>
      </div>
    );
  }
  
  // Construire les onglets selon les permissions
  const tabs = [
    // Général - accessible à tous ceux qui ont accès aux settings
    { 
      id: 'general', 
      label: 'Général', 
      content: <GeneralSettings /> 
    },
    
    // Comptabilité - accessible aux comptables et admins
    ...(can('view_accounts') ? [{ 
      id: 'accounting', 
      label: 'Comptabilité', 
      content: (
        <div className="space-y-6">
          <AccountingSettings />
          <AccountingLevelSettings />
        </div>
      )
    }] : []),
    
    // Sécurité - admin seulement
    ...(can('manage_settings') ? [{ 
      id: 'security', 
      label: 'Sécurité', 
      content: <SecuritySettings /> 
    }] : []),
    
    // Notifications - accessible à tous
    { 
      id: 'notifications', 
      label: 'Notifications', 
      content: <NotificationSettings /> 
    },
    
    // Intégrations - admin seulement (manage_integrations)
    ...(can('manage_integrations') || isAdmin ? [{ 
      id: 'integrations', 
      label: 'Intégrations', 
      content: <IntegrationSettings /> 
    }] : [])
  ];

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-foreground">Paramètres</h1>
      <div className="card">
        <Tabs tabs={tabs} />
      </div>
    </div>
  );
}